import FAQForEmployees from './FAQForEmployees';
import FAQForEmployers from './FAQForEmployers';
import { useTranslation } from 'react-i18next';

export const useFaqData = () => {
  const { t } = useTranslation();
  return {
    getTabsData: () => [
      {
        key: '1',
        label: t('FAQ.employees.label'),
        children: <FAQForEmployees />,
      },
      {
        key: '2',
        label: t('FAQ.employers.label'),
        children: <FAQForEmployers />,
      },
    ],
    getHeaderData: () => ({
      employees: {
        header: t('FAQ.employees.headerText.header'),
        description: t('FAQ.employees.headerText.description'),
      },
      employers: {},
    }),
    getInstructionsData: () => ({
      employees: {
        header: t('FAQ.employees.instructions.header'),
        description: t('FAQ.employees.instructions.description'),
        steps: [
          {
            key: 1,
            title: t('FAQ.employees.instructions.steps.goToWebSite'),
            url: 'https://career.uwed.uz',
          },
          {
            key: 2,
            title: t('FAQ.employees.instructions.steps.studentButton'),
          },
          {
            key: 3,
            title: t('FAQ.employees.instructions.steps.loginButton'),
          },
          {
            key: 4,
            title: t('FAQ.employees.instructions.steps.personalData'),
          },
        ],
      },
    }),
    getFAQData: () => ({
      employees: {
        faqTitle: t('FAQ.employees.askedQuestions'),
        items: [
          {
            key: '1',
            label: t('FAQ.employees.accessToAccount.header'),
            description: t('FAQ.employees.accessToAccount.content'),
          },
          {
            key: '2',
            label: t('FAQ.employees.findingJob.header'),
            description: t('FAQ.employees.findingJob.content'),
          },
          {
            key: '3',
            label: t('FAQ.employees.viewingJVacancies.header'),
            description: t('FAQ.employees.viewingJVacancies.content'),
          },
          {
            key: '4',
            label: t('FAQ.employees.firstYearStudent.header'),
            description: t('FAQ.employees.firstYearStudent.content'),
          },
          {
            key: '5',
            label: t('FAQ.employees.creatingResume.header'),
            description: t('FAQ.employees.creatingResume.content'),
          },
          {
            key: '6',
            label: t('FAQ.employees.multipleJobs.header'),
            description: t('FAQ.employees.multipleJobs.content'),
          },
          {
            key: '7',
            label: t('FAQ.employees.costOfPlatform.header'),
            description: t('FAQ.employees.costOfPlatform.content'),
          },
          {
            key: '8',
            label: t('FAQ.employees.requirementsGettingJob.header'),
            description: t('FAQ.employees.requirementsGettingJob.content'),
          },
        ],
      },
    }),
  };
};
